export const base64Encode = async (string: string) => {
    let tmp: any;
    try {
        const buff = await Buffer.from(string, 'utf-8');
        tmp = buff.toString('base64');
    } catch (error) {
        console.log({...error});
        tmp = Promise.reject('Error');
    }
    return tmp;
}


type EffectFn = (payload: any) => void;
export const request_dispatch = (
    type: { default: string; success: string; fail: string },
    request: Promise<any>,
    creators: [Function?, Function?] = [],
    effect?: EffectFn
) => {
    return (dispatch: any): Promise<any> => {
        const [success, fail] = creators || [];
        dispatch({ type: type.default });
        return request
            .then((payload) => {
                success
                    ? dispatch(success(payload))
                    : dispatch({ type: type.success, payload });
                if (effect) effect(payload);
                return Promise.resolve(payload);
            })
            .catch((error) => {                
                fail
                    ? dispatch(fail(error))
                    : dispatch({ type: type.fail, error });
                return Promise.reject(error);
            });
    };
};